import { BaseTranslation } from 'src/i18n/i18n-types';

export const login: BaseTranslation = {
  login: 'Sign in',
  logIn: 'Log In',
  logInToYourMBAccount: 'Log in to your\n MagicBrief account',
  or: 'or',
  signUp: 'Join MagicBrief',
  signUpDisclaimer:
    "By continuing, you agree to MagicBrief's \n <>Terms of Use<> and <>Privacy Policy<>",
  register: 'Create Account',
  cantLogin: "Can't sign in?",
  signUpForAccount: 'Create an account',
  alreadyHaveAccount: 'Already have a MagicBrief account? <>Sign in<>',
  password: 'Password',
  repeatPassword: 'Repeat Password',
  displayName: 'Full Name',
  emailPlaceholder: 'Email Address',
  enterEmail: 'Enter email address',
  signUpToSave: 'Sign Up to Save Ad',
  autofocusEmailARIA: 'MagicBrief registration form email address',
  google: 'Continue with Google',
  microsoft: 'Continue with Microsoft',
  resetPassword: 'Reset Password',
  sendResetInstructions: 'Send Reset Instructions',
  resetSent: 'Password reset instructions have been sent to {email}',
  passwordReset: 'Password reset successfully.',
  createAccountHeading: 'Welcome to MagicBrief',
  createAccountSubheading: "Let's get your account set up.",
  sentLoginCode: 'We sent a temporary login code to {email}',
  notYou: 'Not you?',
  alreadyHaveAnAccount: 'Already have an account?',
  errors: {
    emailExists: 'An account with that email address already exists.',
    repeatPassword: 'You must enter your password again.',
    minPassword: 'Password must be at least 8 characters.',
    matchPasswords: "The passwords don't match. Re-enter them and try again.",
    emailNotVerified: "Email address hasn't been verified.",
    accountExistsWithDifferentCredential:
      'There is already an account associated to the email provided. If you tried creating an account with Google or Microsoft then you may already have a regular email + password account. If you tried creating an account with an email, you may already have a Google or Microsoft account linked.',
    disabledAccount: 'The requested account has been disabled.',
    noUser:
      "We couldn't find a user matching those details. Please check the email and password you have entered and try again.",
    noEmail: "We couldn't find an account with that email.",
    tooManyRequests:
      'The maximum number of failed sign in attempts has been exceeded and the account has been temporarily disabled. Please try again later or contact support for assistance.',
    resetLinkExpired:
      'The password reset link has expired. Try requesting a new link and try again.',
    resetLinkInvalid:
      'The password reset link is invalid. Try opening the link in your email again, or request a new link.',
    weakPassword:
      'The new password is too weak. Try adding additional characters to make the password harder to guess.',
    resetLinkNoAccount:
      'The password could not be reset as the account is either disabled or does not exist.',
    codeLength: 'Code must be 6 digits long',
  },
  useWorkEmail: 'Use your work email for extra features!',
};
